import { IDepartmentInfo } from 'src/app/shared/user-view/models/tenant-user-access.model';

export function workingCopyDepartmentToActivate(
  departmentIds: string[] | null | undefined,
  currentDepartmentId: string | null | undefined,
  availableDepartments: IDepartmentInfo[]
): IDepartmentInfo | undefined {
  const ids = (departmentIds ?? []).filter((id) => id !== '');
  if (ids.length === 0 || ids.includes(currentDepartmentId ?? '')) {
    return undefined;
  }

  const accessibleIds = new Set(availableDepartments.map((department) => department.id));
  const targetId = ids.find((id) => accessibleIds.has(id));
  return availableDepartments.find((department) => department.id === targetId);
}
